<template>
  <div>
    <div class="news">
      <div class="news__container">
        <div class="news__head card">
          <div class="news__date">
            <svgo-calendar class="icon" width="20" height="20" />
            {{ date }}
          </div>
          <h1 class="news__title">{{ newsData.name }}</h1>
          <div v-if="project" class="news__project">
            <a
              :href="project.sharedLink"
              target="_blank"
              class="news__project-link"
            >
              <div class="news__project-cover">
                <img :src="projectCover || projectDefaultCover" alt="" />
              </div>
              <div>
                <p class="news__project-head">{{ $t('news.project_news') }}</p>
                <p class="news__project-name">{{ project.name }}</p>
              </div>
              <svgo-arrow-right class="icon" />
            </a>
          </div>
        </div>
        <div class="news__cover">
          <img :src="newsData.cover?.data || newsDefaultCover" alt="" />
        </div>
        <div class="news__description card" v-html="newsData.description" />
      </div>
    </div>
    <ModalsQrcode />
  </div>
</template>

<script setup>
import newsDefaultCover from '~/assets/images/news/newsDefaultCover.jpg';
import projectDefaultCover from '~/assets/images/project/projectDefaultCover.jpg';
import useLanguageStore from '~/store/language';
import { format, fromUnixTime } from 'date-fns';
import { enUS, hy, ru } from 'date-fns/locale';

import camelcaseKeys from 'camelcase-keys';
const { $useApi } = useNuxtApp();

const { object: newsData } = defineProps({
  id: {
    type: String,
    required: true,
  },
  object: {
    type: Object,
    default: () => ({}),
  },
});

const headers = computed(() => useCustomRequestHeaders());

const { data: project } = await useFetch(
  $useApi.project.getProject(newsData.projectId),
  {
    key: `project-${newsData.projectId}`,
    headers,
    transform: (response) => camelcaseKeys(response, { deep: true }),
  }
);

const activeLanguage = computed(() => useLanguageStore().activeLanguage);
const dateFnsLocale = computed(() => {
  switch (activeLanguage.value.value) {
    case 'ru':
      return ru;
    case 'en':
      return enUS;
    case 'hy':
      return hy;
  }

  return enUS;
});

const date = computed(() => {
  if (newsData?.createdAt) {
    const newDate = fromUnixTime(newsData.createdAt);
    return format(newDate, 'dd MMMM yyyy', { locale: dateFnsLocale.value });
  }
  return '';
});

const projectCover = computed(() => {
  if (!project.value) return null;
  const covers = [...project.value.covers].filter(
    (cover) => cover.type === 'image'
  );
  return covers[0]?.data;
});

watch(
  () => newsData,
  () => {
    setSeoData();
  }
);

setSeoData();

function setSeoData() {
  useSeoData().set({
    title: newsData.name,
    description: newsData.description,
    image: newsData.cover?.data || newsDefaultCover,
  });
}
</script>

<style lang="scss">
@use '@styles/components/pages/news.scss' as *;
</style>
